<template>
  <div class="view pa24">
    <el-form ref="ruleForm" label-position="top" class="demo-ruleForm">
      <el-form-item>
        <div class="flex-a-c ">
          <p class="fs9 fwbold mr10">{{ $t('miniprogram', 'forceLoginAuthSwitch') }}</p>
          <el-switch v-model="infoSwitch" @change="switch_tap(infoSwitch)">
          </el-switch>
        </div>
        <div>
          {{ $t('miniprogram', 'forceLoginAuthDesc') }}
        </div>
      </el-form-item>
      <el-form-item>
        <div class="flex-a-c ">
          <p class="fs9 fwbold mr10">{{ $t('miniprogram', 'phoneAuthSwitch') }}</p>
          <el-switch v-model="phoneSwitch" @change="switch_tap(phoneSwitch)">
          </el-switch>
        </div>
        <div>
          {{ $t('miniprogram', 'phoneAuthDesc') }}
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { switchCompanyModel, querySwitchCompanyModel } from '@/api/wechat'
import { fetchCompany } from '@/api/companyManage.js'
import i18nMixin from '@/mixins/i18nMixin'

export default {
  mixins: [i18nMixin],
  data() {
    return {
      infoSwitch: false,
      phoneSwitch: false,
      companyId: ''
    };
  },
  created() {
    this.getCompany()
  },
  methods: {
    getCompany() {
      fetchCompany()
        .then(res => {
          console.log(res)
          this.companyId = res.data.companyId
          let data = {
            companyId: this.companyId
          }
          querySwitchCompanyModel(data)
            .then(res => {
              if (res.data) {
                this.infoSwitch = res.data.infoSwitch
                this.phoneSwitch = res.data.phoneSwitch
              }
            })
        })
    },
    switch_tap() {
      let data = {
        infoSwitch: this.infoSwitch,
        phoneSwitch: this.phoneSwitch,
        companyId: this.companyId
      }
      switchCompanyModel(data)
        .then(res => {
          if (res.code == 200) {
            this.$message.success(this.$t('miniprogram', 'operationSuccess'))
          } else {
            this.$message.error(this.$t('miniprogram', 'operationFailed'))
          }
        })
    }
  }
};
</script>
